import Vuex from "vuex";

//`sidebar_drawer` se persistia y quedaba pegado en false: en desktop el drawer es permanente y
//nada volvia a ponerlo en true, por lo que el sidebar quedaba fuera de pantalla para siempre.
//Se limpia la clave vieja para recuperar a los usuarios que ya la tienen guardada.
localStorage.removeItem("sidebar_drawer");

export default new Vuex.Store({
  state: {
    sidebar: {
      open: localStorage.getItem("sidebar_open") !== null ? JSON.parse(localStorage.getItem("sidebar_open")) : true,
      //Visible/oculto. No se persiste, App.vue lo inicializa segun el breakpoint actual.
      drawer: true,
    },
    config: {
      items_per_page: 50,
    },
    logo: localStorage.getItem("logo"),
    asn_filters: { }
  },
  mutations: {
    setOpenSidebar: function (state, payload) {
      if (payload.open != undefined) {
        state.sidebar.open = payload.open;
        localStorage.setItem("sidebar_open", JSON.stringify(payload.open));
      }
      if (payload.drawer != undefined) {
        state.sidebar.drawer = payload.drawer;
      }
    },
    setLogo: function (state, payload) {
      state.logo = payload;
      localStorage.setItem("logo", payload);
    },
    setAsnFilters: function (state, payload) {
      state.asn_filters = payload;
    }
  },
  actions: {},
  modules: {},
});
